<style type="text/css">

</style>
<template>
  <div class="new_terms" >
    
    <form class="forms-sample" style="border-radius: 10px; border: 1px solid gainsboro" >
      <h5 class=" sub-title mb-3 font-weight-bold color-default">{{ formHeader }}</h5>
      <!-- body input -->
      <div v-if="isLoader">
        <b-row>
          <b-col cols="12">
            <b-skeleton-img no-aspect height="50px" width="100%"></b-skeleton-img>
          </b-col>
          </b-row>
        <b-row>
          <b-col cols="6">
            <b-skeleton-img no-aspect height="50px" width="100%"></b-skeleton-img>
          </b-col>
          <b-col cols="6">
            <b-skeleton-img no-aspect height="50px" width="100%"></b-skeleton-img>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-skeleton-img no-aspect height="150px" ></b-skeleton-img>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <div class="form-group">
            <label class="label-form" for="title">Title<span style="color: red">*</span>:</label>
            <input type="text" class="form-control" id="title" v-model="contractForm.title"
              placeholder="The title of content" />
        </div>
        <div class="row">
          <div class="col-md-6">     
            <label class="label-form">Due Date:</label>
            <input class="form-control"  type="date" v-model="contractForm.due_date"/>
          </div> 
          <div class="col-md-6">
              <label class="label-form">Status<span style="color: red">*</span>:</label>

              <multiselect :options="selected_status"  placeholder='Select Status' :multiple="false"
                  :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true" 
                  v-model="contractForm.status" label="name" track-by="value" style="font-size:12px !improtant">

                </multiselect>
          </div>
        
        </div>
        <div class="form-group mt-3">
          <label class="label-form" for="description">Content<span style="color: red;">*</span>:</label>
          <div class="text_editor">
            <tiny-mce-editor :vModelName.sync="contractForm.body"></tiny-mce-editor><br>
          </div>
        </div>

        <div class="text-right">
          <button v-if="this.$route.params.contract === undefined" class="btn btn-default" @click.prevent="save">Save</button>
          <button v-else class="btn btn-default" @click.prevent="update">Update</button>
          <button  class="btn btn-secondary ml-2" @click.prevent="cancel">Cancel</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import axios from 'axios';
  import 'jodit/build/jodit.min.css';
  import JoditVue from 'jodit-vue';
  import TinymceEditor from '../../views/partials/tiny_mce_editor';
  import Multiselect from 'vue-multiselect';

  export default {
    components: {
      Multiselect,
      JoditVue,
      'tiny-mce-editor': TinymceEditor,
    },


    data: function () {
      return {
        formHeader: '',
        contractForm: {
          remove_image: false
        },

        buttons: [
          'bold', 'strikethrough', 'underline', 'italic', '|',
          'ul', 'ol', '|',
          'image', 'table', 'link', '|',
          'outdent', 'indent', '|',
          'align', 'undo', 'redo', '|',
          'hr', 'symbol', 'fullsize'
        ],
        config: {
          "uploader": {
            "insertImageAsBase64URI": true
          }
        },
        selected_status: [
            {name:"Inactive", value:0},
            {name:"Active", value:1}
          ],
        isLoader: true,
      };
    },
    computed: {
      contracts: function () {
        return this.$store.getters['termsandconditions/contracts'];
      }
    },
    created: function () {
      if (typeof this.$route.params.contract === 'undefined') {
        this.formHeader = 'New Contract';
        this.contractForm = {
          id:0,
          title:'',
          status:'',
          due_date:new Date().toISOString().slice(0, 10),
          body: '',
        };
      }else if (this.$route.params.contract !== undefined) {
        this.formHeader = 'Update Contract';
        this.$store.dispatch('termsandconditions/getContract',this.$route.params.contract ).then((response) => {
          this.contractForm = {
            id:response.data.id,
            title:response.data.title,
            status:this.selected_status[response.data.status],
            due_date:response.data.due_date,
            body: response.data.content,
          };
        });
      }
      setTimeout(() => {
          this.isLoader = false;
        },200);
    },

    methods: {
      save() {
        let body = this.contractForm.body.replace(/(<([^>]+)>)/gi, '');
        let formatted_body = body.trim();
        if (formatted_body == ''||this.contractForm.title == ''||this.contractForm.status == '') {
          this.$toast.error("Fill all the required fields");
        }else{
          this.$store.dispatch('termsandconditions/createContract',[this.contractForm,'']).then((response) => {
            if(!response.error){
              this.$store.dispatch('termsandconditions/getAllContracts');
              this.$router.push('/customer-contracts');
              this.$toast.success(response.message);
            }else{
              this.$toast.error(response.message);
            }
          }).catch((error) => {
            console.log(error)
          });
        }
      },
      update(){
        let body = this.contractForm.body.replace(/(<([^>]+)>)/gi, '');
        let formatted_body = body.trim();
        if (formatted_body == ''||this.contractForm.title == ''||this.contractForm.status == '') {
          this.$toast.error("Please Fill All Required Fields");
        }else{
          this.$store.dispatch('termsandconditions/updateContract',[this.contractForm,'']).then((response) => {
            if(!response.error){
              this.$store.dispatch('termsandconditions/getAllContracts');
              this.$router.push('/customer-contracts');
              this.$toast.success(response.message);
            }else{
              this.$toast.error(response.message);
            }
  
          }).catch((error) => {
            console.log(error);
          });
        }
      },
      cancel(){
        this.$router.push('/customer-contracts');
      }
    }
  }
</script>
<style>

input[type="date"]{
  position: relative;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    background-position: right;
    background-size: auto;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    top: 9px!important;
    right: 2%;
    width: auto;
}  
</style>